<!-- <div>
    <kendo-gridlayout [align]="{ horizontal: hAlign, vertical: vAlign }">
        <kendo-gridlayout-item [col]="1" [row]="1">
            <div kendoTypography variant="p" style="text-align: left; margin-top: 7px; margin-bottom: 7px;" class="screenLarge">For questions, comments, or access requests please submit an incident <a target="_blank" href="http://hdbstech/support/Incidents/New">here</a>.</div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="2" [row]="1">
            <div style="display: flex; justify-content: center;"><div class="bg-Drill_Bits_Horz center-block"></div></div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="3" [row]="1">
            <div kendoTypography variant="p" style="text-align: right; margin-top: 7px; margin-bottom: 7px;" class="screenLarge">&copy; {{ Today | date:'y' }} - Halliburton Drill Bits and Services</div>
        </kendo-gridlayout-item>
    </kendo-gridlayout>
</div> -->
<div class="!k-bg-dark k-color-subtle k-bg-light k-py-6 k-px-15 k-px-sm-15 k-px-md-15 k-px-lg-15 k-px-xl-15" style="text-align: center; padding-top: 10px;">
    <p class="!k-mb-0">Copyright © {{currentYear}} Halliburton. All rights reserved.</p>
</div>
